<template lang="pug">
.report 
  WebTemplate(
    pagetitle= "新老访客",
    tip= "新老访客报告帮助您查看您网站不同人群的流量分布、行为特征，从而对不同人群进行管理并优化营销策略",
    :currentTab= "currentTab",
    :total= "total",
    :pg= "pg",
    :ps= "ps",
    :tablist= "tablist",
    :tableDataList= "tableDataList",
    :hasCheckBox= "hasCheckBox",
    :checkboxLength= "checkboxLength",
    :sum= "sum",
    :order= "order",
    :yAxis= "yAxis",
    :legend= "legend", 
    :chartXAxis= "chartXAxis",
    :chartSeries= "chartSeries",
    @indiceChange= "indiceChange",
    @tableUpdate= "getTableData",
    @tablesorter= "tablesorter",
    :customIndice= "customIndice",
    :twoIndiceShow= "twoIndiceShow",
    :twoIndice= "twoIndice")

    div.nav-tabs(slot="nav-tabs")
      TabContent(
        title="主维度：",
        :tablist="tablist",
        :update="updateTab",
        :currentTab="currentTab")
        div.right-tab(slot="extentTab")
          DownloadBtn(
            :reportApi="reportApi",
            :params="query",
            pagetitle="新老访客报表",
            subtitle="",
            v-if="total > 0",
            style="float: right;")
          CustomIndice(
            :defaults="defaultCustomIndices"
            @change="onCustomIndiceChange")
        div(slot="common") 
          p.plan-nav
            | 选择二级维度：
            v-radio-group(
              v-model="sdim",
              name="secondaryDim",
              :options="sdimOptions",
              @change.native="sdimChange")
          p.tabAction
            button.btn.btn-primary.btn-big(
              :disabled="fetchLineChartabled",
              @click="fetchLineChartData") 绘制选定行
</template>

<script>
  import Vue from 'vue'
  import Store from '../../store/store.js'
  import Mixin from '../mixin.js'
  import { INDICE_DEFAULT } from './constants.js'
  import WebTemplate from './template'
  import { mapState, mapActions, mapGetters } from 'vuex'
  export default {
    store: Store,
    components: {
      WebTemplate
    },
    mixins: [Mixin],
    data () {
      return {
        chartResList: [],
        hasCheckBox: true,
        checkboxLength: 3,
        total: 0,
        pg: 1,
        ps: 10,
        sdim: 'null',
        currentTab: 'newold',
        isasc: 0,
        order: 'pv',
        legend: [],
        yAxis: [],
        tablist: [
          {
            id: 'newold',
            name: '新老访客',
            order: 'pv',
            reportTableApi: '/api/report/newold?groupby=newold',
            basicSummaryStatApi: '/api/report/newold?groupby=newold&issum=1',
            reportLineChartApi: '/api/report/newold?groupby=newold'
          }
        ],
        chartXAxis: [],
        chartSeries: [],
        customIndice: 'pv',
        twoIndice: '',
        twoIndiceShow: true,
        sum: {},
        tableDataList: [],
        defaultCustomIndices: ['pv', 'uv', 'ipnum', 'newvst', 'atime', 'tnum'],
        sdimOptions: []
      }
    },
    computed: {
      ...mapState('web', {
        tableIndices: state => state.tableIndices,
        compared: state => state.compared,
        compareStart: state => state.compareStart,
        compareEnd: state => state.compareEnd
      }),
      ...mapGetters('web', [
        'indicesMenu',
        'domainId',
        'uiError',
        'fetchLineChartabled',
        'twoIndiceSelectabled'
      ]),
      query () {
        let query = {
          isasc: this.isasc,
          order: this.order,
          domainId: this.domainId,
          pvtype: 0,
          start: this.$store.state.start,
          end: this.$store.state.end,
          cycle: this.$store.state.start == this.$store.state.end ? 'hour' : 'day',
          timespan: new Date().getTime(),
          djid: this.dianjingID,
          mdim: this.currentTab
        }
        if (this.sdim != 'null') {
          query = _.assignIn({
            sdim: this.sdim
          }, query)
        }
        if (this.compared) {
          query = _.assignIn({
            compareStart: this.compareStart,
            compareEnd: this.compareEnd
          }, query)
        }
        return query
      },
      reportApi () {
        return _.find(this.tablist, {id: this.currentTab}).reportTableApi
      }
    },
    watch: {
      domainId () {
        this.clearKeyword()
        this.getTableData()
      },
      compared: function (newVal, oldVal) {
        this.compared = newVal
        this.resetIndice()
        if (newVal) {
          this.checkboxLength = 1
        } else {
          this.checkboxLength = 3
        }
      },
      uiError () {
        if (this.uiError.errMsg) {
          this.$Modal.warn(this.uiError.errMsg)
        }
      }
    },
    created () {
      this.setTableIndices(this.defaultCustomIndices)
    },
    methods: {
      ...mapActions('web', {
        setTableIndices: 'SET_TABLE_INDICES'
      }),
      onCustomIndiceChange (indices) {
        this.setTableIndices(indices)
      },
      updateTab: function (tab) {
        if (this.currentTab == tab) return
        this.resetTab(tab)
        this.resetIndice()
        this.getTableData()
      }
    }
  }
</script>
<style scoped>
.search {
  float: right;
}
.right-tab a {
  float: left;
}
</style>



// WEBPACK FOOTER //
// generation.vue?614a5362